/**
 * `Project_Registry.ts` — port of `AI/Registry/Project_Registry.cs`.
 *
 * Web slice: `create_new_project` is deferred until the draft-creation flow
 * is exposed through a model the executor can call safely.
 */

import { AgentToolNames } from "./agentToolNames";
import {
  type AIAgentTool,
  buildParams,
  stringParam,
} from "./AIAgentToolRegistryModel";

export function addProjectTools(tools: AIAgentTool[]): void {
  tools.push(
    {
      name: AgentToolNames.GetAvailableProjects,
      category: "Context",
      labelWhenActive: "Listing projects...",
      description:
        "Returns the projects available to the current user with their names and project_id values. Use the exact project_id from this tool when calling Open_Project. Always call fresh - the project list can change at any time.",
      humanDescription: "List the projects available to the user.",
      parameters: buildParams(),
      enabled: true,
      writerOnly: false,
    },
    {
      name: AgentToolNames.OpenProject,
      category: "Navigation",
      labelWhenActive: "Opening project...",
      description: `Opens a project by its exact project_id from ${AgentToolNames.GetAvailableProjects}. Navigates the editor to that project.`,
      humanDescription: "Open a project by id.",
      parameters: buildParams({
        project_id: stringParam("Exact project_id from Get_Available_Projects.", false),
      }),
      enabled: true,
      writerOnly: false,
    },
    {
      name: AgentToolNames.ExitProject,
      category: "Navigation",
      description:
        "Closes the current project and returns to the projects list. Use when the user asks to exit, close, or leave the project.",
      humanDescription: "Close the current project and return to the projects list.",
      parameters: buildParams(),
      enabled: true,
      writerOnly: false,
    },
  );
}
